import merge from 'lodash/merge';
import FHIRObjectBase from './FHIRObjectBase';
import Reference from './types/Reference';

export default class MeasurementSource extends FHIRObjectBase {
    static __className = 'MeasurementSource';

    __objectStructure = {
        type: String,
        customText: String,
        method: String,
        value: String,
        scale: String,
        report: [Reference],
    };

    constructor(constructJson, className = 'MeasurementSource') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
